<template>
  <button
    type="button"
    class="mmp-nightmode-btn"
    :class="{ 'mmp-nightmode-btn--active': active }"
    :title="active ? 'Switch to day mode' : 'Switch to night mode'"
    @click="$emit('toggle')"
  >
    <!-- Moon (night mode off) -->
    <svg
      v-if="!active"
      class="mmp-nightmode-icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
        fill="currentColor"
      />
    </svg>
    <!-- Sun (night mode on) -->
    <svg
      v-else
      class="mmp-nightmode-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="4" fill="currentColor" stroke="none" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'MMP_ANSI_NightModeToggle',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.mmp-nightmode-btn {
  width: 40px;
  height: 40px;
  background-color: #063c6d;
  border: 2px #063c6d solid;
  border-radius: 5.5px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.mmp-nightmode-btn:hover {
  background-color: #0a5499;
  border-color: #0a5499;
}

.mmp-nightmode-btn--active {
  background-color: #f5c542;
  border-color: #f5c542;
  color: #063c6d;
}

.mmp-nightmode-btn--active:hover {
  background-color: #ffd45c;
  border-color: #ffd45c;
}

.mmp-nightmode-icon {
  width: 22px;
  height: 22px;
}
</style>
